import Api from './ApiService'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`categories?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`categories/${id}`);
    },
    create(data) {
        return Api().post(`categories`, data);
    },
    update(data) {
        return Api().put(`categories/${data.id}`, data);
    }
}